import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgNieuweBerging = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m26 18 9 4.07V36H17V22z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M29 25.17h-6V36h6z"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m5 8-.04 28H17V13L8 5z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m25.993 20.217-10.25 4.55-.406-.914 10.25-4.55z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M15 6h-4v6.18h4z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgNieuweBerging);

export default ForwardRef;
